import { styled } from "@material-ui/core";
import Imgix from "react-imgix";
import SwipeableViews from "react-swipeable-views";
import PodVideo from "../../../../../components/pod-video";

export const IMAGE_DESKTOP_SIZE = 325;
const DESKTOP_SIZE_PX = `${IMAGE_DESKTOP_SIZE}px`;
const SM_SIZE = `35vw`;
const XS_SIZE = `min(70vw, ${DESKTOP_SIZE_PX})`;

export const CustomSwipeableViews = styled(SwipeableViews)(({ theme }) => ({
  width: `calc(${DESKTOP_SIZE_PX} + ${theme.spacing(2)}px)`,
  height: DESKTOP_SIZE_PX,
  "& .react-swipeable-view-container": {
    width: "100%",
    height: "100%",
    "& > div": {
      width: "100%",
      height: "100%",
      overflow: "hidden !important",
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      "& > img": {
        cursor: "pointer",
        width: DESKTOP_SIZE_PX,
        height: DESKTOP_SIZE_PX,
        borderRadius: "3px"
      }
    }
  },
  [theme.breakpoints.only("sm")]: {
    width: `calc(${SM_SIZE} + ${theme.spacing(2)}px)`,
    height: SM_SIZE,
    "& img": {
      width: `${SM_SIZE} !important`,
      height: `${SM_SIZE} !important`
    }
  },
  [theme.breakpoints.only("xs")]: {
    width: `calc(${XS_SIZE} + ${theme.spacing(2)}px)`,
    height: XS_SIZE,
    "& img": {
      width: `${XS_SIZE} !important`,
      height: `${XS_SIZE} !important`
    }
  }
}));

export const PodImgix = styled(Imgix)(({ theme }) => ({
  position: "absolute",
  bottom: `${theme.spacing(-1)}px`,
  right: `${theme.spacing(-1)}px`
}));

export const CustomPodVideo = styled(PodVideo)(({ theme }) => ({
  bottom: theme.spacing(-4),
  right: theme.spacing(-4)
}));
